<template>
    <v-container max-width="100%" style="margin-top: 2%">
      <template>
        <v-row justify="center">
          <v-dialog v-model="confirmDialog" persistent max-width="500">
            <v-card>
              <v-card-title class="headline">
                <span style="color: #d60000">{{ $t('system.alert') }}</span>
              </v-card-title>
              <v-card-text>
                <span style="color: #d60000">{{ this.mensagemdialog }}</span>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red accent-4"
                  class="white--text"
                  @click="confirmDialog = false"
                  >{{ this.messageDismissButton }}</v-btn
                >
                <v-btn
                  v-if="showConfirmButton"
                  color="red accent-4"
                  class="white--text"
                  @click="deleteFromDatabase"
                  >{{ this.messageConfirmButton }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>

    <v-container>
      <v-row justify="center" align="center">
        <v-col cols="12" sm="12" md="12" align="center">
          <v-card>
            <v-card-title>
              <span class="headline" style="color: #4a4a4a">{{ $tc('holiday.self', 2) }}</span>
              <v-spacer></v-spacer>
              <ExportTablePdf :title="$t('holiday.self')" :content="filteredFeriados" :headers="headers"
                filename="feriados"></ExportTablePdf>
            </v-card-title>
            <v-card-text>
              <v-dialog v-model="dialog" max-width="80%">
                <v-card>
                  <v-card-title>
                    <span class="headline" style="color: #4a4a4a">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-form ref="form" v-model="formValidado">
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field v-model="descricao" :label="$t('holiday.description') + ' *'"
                              :rules="[(v) => !!(v) || $t('holiday.requiredDescription')]"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" class="white--text" @click="close">{{ $t('button.cancel') }}</v-btn>

                    <v-btn color="primary darken-1" class="white--text" @click="save">{{ $t('button.save') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-row>
                <v-col cols=12 sm="12" md="6">
                  <v-data-table :headers="headers" :items="filteredFeriados" :search="search" :loading="loadingFeriados"
                    sort-by="dt_inicio" dense class="elevation-7" locale="pt" style="border-radius: 10px;">
                    <template v-slot:item.actions="{ item }">
                      <v-icon small class="mr-2" color="green" @click="editItem(item)"
                        :disabled="!!item.is_editable || !canEdit">mdi-pencil</v-icon>

                      <v-icon small class="mr-2" color="red" @click="deleteItem(item)"
                        :disabled="!!item.is_editable || !canDelete">mdi-delete</v-icon>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col cols=12 sm="12" md="6">
                  <v-date-picker full-width no-title :events="events" event-color="primary" scrollable
                    v-model="dateSelected" :min="today" multiple @input="dateSelectedChange">
                  </v-date-picker>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" class="white--text" @click="cancel">{{ $t('button.cancel') }}</v-btn>

              <v-btn color="primary darken-1" class="white--text" @click="confirm">{{ $t('button.save') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>


<script>

import apiController from "@/utils/apiController";
import ExportTablePdf from "./ExportTablePdf.vue";
import EventBus from '../utils/eventBus';

export default {
  components: {
    ExportTablePdf  
  },
  data: () => ({
    search: "",
    user: null,
    token: null,
    erro: null,
    showConfirmButton: true,
    messageConfirmButton: "", // Inicializado no mounted
    messageDismissButton: "", // Inicializado no mounted
    formValidado: true,
    showAlert: false,
    mensagemAlerta: "",
    tipoAlerta: "success",
    dialog: false,
    operacao: 0,
    confirmDialog: false,
    mensagemdialog: "",
    dateSelected: [],
    feriados: [],
    filteredFeriados: [],
    editedIndex: -1,
    isFeriadoDisabled: false,
    loadingFeriados: false,
    descricao: null,
    editedItem: {
      id_feriado: null,
      dt_inicio: null,
      dt_fim: null,
      descricao_feriado: null,
    },
    deletedItem: {
      id_feriado: null,
      dt_inicio: null,
      dt_fim: null,
      descricao_feriado: null,
    },
    defaultItem: {
      id_feriado: null,
      dt_inicio: null,
      dt_fim: null,
      descricao_feriado: null,
    },
    recursos: [],
    canInsert: false,
    canEdit: false,
    canDelete: false,
  }),
  computed: {
    formTitle() {
      // Retorna o título do formulário baseado na operação
      return this.editedIndex === -1 ? this.$t('holiday.new') : this.$t('holiday.edit');
    },
    today() {
      // Retorna a data atual no formato YYYY-MM-DD
      return new Date().toISOString().substring(0, 10);
    },
    events() {
      // Retorna as datas dos feriados para o calendário
      return this.feriados.map((f) => {
        return f.dt_inicio.substring(0, 10);
      })
    },
    headers() {
      return [
        { text: this.$t('holiday.idholiday'), value: "id_feriado", align: " d-none" },
        { text: this.$t('holiday.description'), value: "descricao_feriado" },
        { text: this.$t('holiday.date'), value: "dt_inicio_formatted" },
        { text: this.$t('schedule.headers.main.actions'), value: "actions", sortable: false },
      ];
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    confirmDialog(val) {
      val || this.cancel();
    },
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    }
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.populaRecursos();
  },
  mounted() {
    // Define os textos dos botões de confirmação e dismiss no mounted, após o i18n estar pronto
    this.messageConfirmButton = this.$t('button.confirm');
    this.messageDismissButton = this.$t('button.dismiss');
  },
  methods: {

    populaRecursos() {
      if (this.user.is_superadmin === 1) {
        apiController.request(apiController.endpoints.getallRecursos, {
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = true;
            this.canInsert = true;
            this.canDelete = true;
            this.initialize();
          },
        });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.user.id_usuario },
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updateferiado");
            this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/insertferiado");
            this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deleteferiado");
            this.initialize();
          },
        });
      }
    },
    initialize() {
      this.loadingFeriados = true;
      apiController.request(apiController.endpoints.getallFeriados, {
          onSuccess: (response) => {
            this.feriados = response.data;
            this.dateSelectedChange();
            this.loadingFeriados = false;
          },
          onError: () => {
            this.loadingFeriados = false;
          },
        });
      },
      editItem(item) {
        this.editedIndex = this.feriados.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.descricao = this.editedItem.descricao_feriado;
        this.dialog = true;
      },
      deleteItem(item) {
        this.deletedItem = Object.assign({}, item);
        this.mensagemdialog = "Confirma a exclusão do feriado " + item.descricao_feriado + " ?";
        this.showConfirmButton = true;
        this.messageDismissButton = "Não";
        this.messageConfirmButton = "Sim";
        this.confirmDialog = true;
      },
      deleteFromDatabase() {
        this.operacao = 2;
        this.confirmDialog = false;
        apiController.request(apiController.endpoints.deleteFeriado, {
          data: this.deletedItem,
          onSuccess: (response) => {
            this.updateTable(response);
          },
        });
      },
      close() {
        this.dialog = false;
        this.$refs.form.resetValidation();
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
          this.descricao = null;
        });
      },
      save() {
        this.$refs.form.validate();
        if (this.formValidado) {
          let temp = this.dateSelected.map((d) => {
            return [d.substring(0,10), this.descricao];
          });

        if (this.editedIndex == -1) {
          this.operacao = 0;
          apiController.request(apiController.endpoints.insertFeriadosbulk, {
            data: temp,
            silent: true,
            onSuccess: (response) => {
              this.updateTable(response);
            },
            onError: (e) => {
              console.log(this.$t('system.messages.errorAxios'));
              console.log(e.message);
              this.erro = {
                type: "Axios",
                message: e.message,
                status: e.response.status
              };
              this.$refs.erroDialog.showError();
            },
          });
        } else {
          this.operacao = 1;
          this.editedItem.descricao_feriado = this.descricao;
          apiController.request(apiController.endpoints.updateFeriado, {
            data: this.editedItem,
            onSuccess: (response) => {
              this.updateTable(response);
            },
          });
          }
        }
      },
      updateTable(response) {
        if (response.data.erro) {
          if (this.operacao == 0) {
            EventBus.$emit('show-alert', { mensagem: this.$t('holiday.updateTable.error.insert') +  response.data.mensagem, tipo: 'error' });
          } else {
            if (this.operacao == 1) {
              EventBus.$emit('show-alert', { mensagem: this.$t('holiday.updateTable.error.update') + response.data.mensagem, tipo: 'error' });
            } else {
              EventBus.$emit('show-alert', { mensagem: this.$t('holiday.updateTable.error.delete') + response.data.mensagem, tipo: 'error' });
            }
          }
          this.tipoAlerta = "error";
          this.showAlert = true;
        } else {
          if (this.operacao == 0) {
            EventBus.$emit('show-alert', { mensagem: this.$t('holiday.updateTable.success.insert'), tipo: 'success' });
          } else {
            if (this.operacao == 1) {
              EventBus.$emit('show-alert', { mensagem: this.$t('holiday.updateTable.success.update'), tipo: 'success' });
            } else {
              EventBus.$emit('show-alert', { mensagem: this.$t('holiday.updateTable.success.delete'), tipo: 'success' });
            }
          }
          this.tipoAlerta = "success";
          this.showAlert = true;
        }
        this.close();
        this.cancel();
        this.initialize();
    },
    formatDate(date, format) {
      if (!date) return "";

      if (format === "local" || !format) {
        let parts = date.split("-");
        return `${parts[2]}/${parts[1]}/${parts[0]}`;
      }

      if (format === "sql") {
        let parts = date.split("/");
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
      }

      return date;
    },
    dateSelectedChange() {
      if (this.dateSelected.length === 0) {
        this.filteredFeriados = this.feriados;
      } else {
        this.filteredFeriados = this.feriados.filter((f) => this.dateSelected.includes(f.dt_inicio.substring(0, 10)));
        this.isFeriadoDisabled = this.dateSelected < this.today;
        this.dateInicial = this.dateSelected; // Manter a lógica original do usuário, mesmo que pareça uma variável não utilizada
      }
    },
    resetDate() {
      this.dateSelected = null;
      this.dateSelectedChange();
    },
    confirm() {
      this.dialog = true;
    },
    cancel() {
      // Revertendo para a lógica original do usuário para a função cancel
      this.dateSelected = [];
      this.filteredFeriados = this.feriados;
    }
  },
};
</script>

<style scoped>
/* Estilos específicos do componente */
</style>
